import React from "react";

function ResidentialIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="#262626"
        d="M17.5 9.374v7.5a.625.625 0 01-.625.625H12.5a.625.625 0 01-.625-.625v-4.062a.312.312 0 00-.313-.313H8.438a.312.312 0 00-.313.313v4.062a.625.625 0 01-.625.625H3.125a.625.625 0 01-.625-.625v-7.5c0-.331.132-.649.366-.883l6.25-6.25a1.25 1.25 0 011.768 0l6.25 6.25c.234.234.366.552.366.883z"
      ></path>
    </svg>
  );
}

export default ResidentialIcon;
